import {cn} from "../../utils/helper";


interface HeroBannerProps {
    message?: string
    className?: string
    image: any
}

export default function HeroBanner({
                                       image,
                                       message = '미분양 브랜딩부터, 현장 완판까지!',
                                       className,
                                   }: HeroBannerProps) {
    return (
        <div
            style={{backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'}}
            className={cn(
                'hidden md:block relative overflow-hidden rounded-[10px]',
                'px-[28px] py-[21px] h-[196px] text-white shadow-soft',
                className,
            )}
        >
            <div className="flex items-center gap-8">

                <p className="absolute right-[28px] bottom-[20px] text-white font-[400] text-[20px]">{message}</p>
            </div>
        </div>
    )
}
